module.exports = __webpack_public_path__ + "static/img/midfielder.7008e4b1.svg";